<template>
<div class="chapter">
<div class="inner_page">
<p class="txc" id="d12e33"><b>Other Books by Gilbert Morris</b></p>
<p class="txc" id="d12e36"><i>Charade</i></p>
<p class="txc" id="d12e39"><i>Jacob’s Way</i></p>
<p class="txc" id="d12e42"><i>Edge of Honor</i></p>
<p class="txc" id="d12e45"><i>Jordan’s Star</i></p>
<p class="txc" id="d12e48"><i>God’s Handmaiden</i></p>
<p class="txc" id="d12e51"><i>The Spider Catcher</i></p>
<p class="txc" id="d12e54"><b>The Singing River Series</b></p>
<p class="txc" id="d12e57"><i>The Homeplace</i></p>
<p class="txc" id="d12e60"><i>The Dream</i></p>
<p class="txc" id="d12e63"><i>The Miracle</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Morr_9780310252344_epub_c1a_r1.vue?07fdbc8c